import { useLayoutEffect, useRef } from 'react';

import { useComparisonKeyImageSelectionStore, useComparisonStore } from '@/store';

interface UseSyncComparisonStoreWithRouteParams {
  isOnComparisonsRoute?: boolean;
  studyId: string;
}

export function useSyncComparisonStoreWithRoute({
  isOnComparisonsRoute = false,
  studyId,
}: UseSyncComparisonStoreWithRouteParams): void {
  const previousStudyIdRef = useRef<string | undefined>(undefined);

  useLayoutEffect(() => {
    if (previousStudyIdRef.current !== studyId) {
      previousStudyIdRef.current = studyId;
      useComparisonStore.getState().reset();
      useComparisonKeyImageSelectionStore.getState().reset();

      return;
    }

    if (isOnComparisonsRoute && useComparisonStore.getState().isOpen) {
      useComparisonKeyImageSelectionStore.getState().reset();
      useComparisonStore.getState().close();
    }
  }, [isOnComparisonsRoute, studyId]);
}
